import { SEO_TDK_MAPPING_TYPES } from "@/constants/seo-constants";
import { Locale } from "@/i18n/config";

export const SEO_TDK_MAPPING: Partial<Record<Locale, SEO_TDK_MAPPING_TYPES>> = {
  en: {
    home: {
      /* prettier-ignore */
      "title": "🚀AFun Online Casino - Casino Games & Sports Betting Brazil",
      /* prettier-ignore */
      "description": "Afun - Play online casino and sports betting with exclusive bonuses in Brazil.",
      /* prettier-ignore */
      "keyword": "online casino Brazil, sports betting, exclusive bonus, play slots, live roulette",
    },
    casino: {
      /* prettier-ignore */
      "title": "🎰 AFun Online Casino - Slots, Roulette & Blackjack in Brazil",
      /* prettier-ignore */
      "description": "Afun - Play over 2,000 online casino games. Popular slots like Fortune Tiger, live roulette and blackjack with real dealers. Fast & secure PIX payments in Brazil.",
      /* prettier-ignore */
      "keyword": "online casino Brazil, slot games, live roulette, blackjack, live casino, PIX payments",
    },
    profile: {
      /* prettier-ignore */
      "title": "AFun Player Profile - Account, History & Bonuses",
      /* prettier-ignore */
      "description": "Manage your AFun account. Track your betting history, claim exclusive bonuses and check your balance in real time.",
      /* prettier-ignore */
      "keyword": "player profile, AFun account, betting history, exclusive bonuses, balance online",
    },
    collections: {
      /* prettier-ignore */
      "title": "📂 AFun Game Collections - Slots, Roulette & Online Casino",
      /* prettier-ignore */
      "description": "Discover AFun’s exclusive game collections. Popular slots, online roulette, jackpots and live casino games organized for every player style.",
      /* prettier-ignore */
      "keyword": "game collections, popular slots, online roulette, jackpots, online casino Brazil",
    },
    "my-profile": {
      /* prettier-ignore */
      "title": "👤 AFun My Account - Profile, Betting History & Exclusive Bonuses",
      /* prettier-ignore */
      "description": "Log in to your AFun account. Manage your profile, check betting history, claim exclusive bonuses and track your balance instantly.",
      /* prettier-ignore */
      "keyword": "my account AFun, player profile, betting history, exclusive bonuses, account balance",
    },
    feedback: {
      /* prettier-ignore */
      "title": "📝 AFun Feedback - Customer Support & Contact",
      /* prettier-ignore */
      "description": "Share your feedback with AFun. Contact our 24/7 support team, ask questions and help improve your online gaming experience.",
      /* prettier-ignore */
      "keyword": "AFun feedback, customer support, contact casino, betting help, 24/7 assistance",
    },
    "personalized-game": {
      /* prettier-ignore */
      "title": "🎮 AFun Personalized Games - Exclusive Recommendations for You",
      /* prettier-ignore */
      "description": "Find casino games tailored to your profile. Slots, roulette and blackjack recommendations based on your preferences at AFun.",
      /* prettier-ignore */
      "keyword": "personalized games, casino recommendations, favorite slots, online roulette, blackjack Brazil",
    },
    "recent-game": {
      /* prettier-ignore */
      "title": "🕹 AFun Recent Games - Pick Up Where You Left Off",
      /* prettier-ignore */
      "description": "Check your recent games on AFun. Continue playing your favorite slots, roulette and blackjack instantly and securely.",
      /* prettier-ignore */
      "keyword": "recent games, last played, casino history, favorite slots, online roulette, blackjack",
    },
    install: {
      /* prettier-ignore */
      "title": "📲 Download AFun App - Install Casino & Sports Betting on Mobile",
      /* prettier-ignore */
      "description": "Download the official AFun app. Install on your mobile and enjoy instant access to online casino, sports betting and exclusive bonuses with PIX.",
      /* prettier-ignore */
      "keyword": "download AFun app, install casino app, sports betting app, online casino Brazil, PIX mobile",
    },
    "wager-contest": {
      /* prettier-ignore */
      "title": "🏆 AFun Wager Contest - Compete for Exclusive Rewards",
      /* prettier-ignore */
      "description": "Join AFun’s wager contests. Climb the leaderboard, earn points and win exclusive rewards in slots and sports betting.",
      /* prettier-ignore */
      "keyword": "wager contest, casino competition, player leaderboard, exclusive rewards, sports betting",
    },
    competition: {
      /* prettier-ignore */
      "title": "🏆 AFun Wager Contest - Compete for Exclusive Rewards",
      /* prettier-ignore */
      "description": "Join AFun’s wager contests. Climb the leaderboard, earn points and win exclusive rewards in slots and sports betting.",
      /* prettier-ignore */
      "keyword": "wager contest, casino competition, player leaderboard, exclusive rewards, sports betting",
    },
    "hot-game": {
      /* prettier-ignore */
      "title": "🔥 AFun Hot Games - Most Popular Slots & Casino Games",
      /* prettier-ignore */
      "description": "Explore the most popular games at AFun. Famous slots, online roulette, blackjack and more all in one place.",
      /* prettier-ignore */
      "keyword": "hot games, popular slots, online roulette, blackjack, trending casino games",
    },
    "casual-games": {
      /* prettier-ignore */
      "title": "🎯 AFun Casual Games - Quick & Fun Online Entertainment",
      /* prettier-ignore */
      "description": "Explore AFun casual games. Quick and entertaining experiences, perfect for relaxing between your favorite bets.",
      /* prettier-ignore */
      "keyword": "casual games, quick play, fun online games, light games, Brazil casino",
    },
    vip: {
      /* prettier-ignore */
      "title": "👑 AFun VIP - Exclusive Program with Special Rewards",
      /* prettier-ignore */
      "description": "Join the AFun VIP program and enjoy exclusive bonuses, personalized support and unique advantages in our online casino.",
      /* prettier-ignore */
      "keyword": "AFun VIP, casino VIP program, exclusive bonuses, special rewards, premium support",
    },
    providers: {
      /* prettier-ignore */
      "title": "🎲 AFun Game Providers - Pragmatic Play, Evolution, NetEnt & More",
      /* prettier-ignore */
      "description": "Discover AFun’s top game providers including Pragmatic Play, Evolution, NetEnt, Red Tiger and more. Licensed and certified online casino games in Brazil.",
      /* prettier-ignore */
      "keyword": "game providers, casino software partners, Pragmatic Play Brazil, Evolution casino, NetEnt slots, Red Tiger games, licensed providers",
    },
    responsible: {
      /* prettier-ignore */
      "title": "✅ AFun Responsible Gaming - Play Safely in Brazil",
      /* prettier-ignore */
      "description": "AFun is committed to responsible gaming. Set limits, play consciously, and access support tools for a safe and enjoyable experience.",
      /* prettier-ignore */
      "keyword": " responsible gaming, safe betting, gambling limits, casino support, awareness",
    },
    "bonus-center": {
      /* prettier-ignore */
      "title": "🛡 AFun Responsible Gaming - Safe & Controlled Play Online",
      /* prettier-ignore */
      "description": "AFun is committed to responsible gaming. Set limits, use self-control tools and enjoy a safe online casino experience with 24/7 support.",
      /* prettier-ignore */
      "keyword": "responsible gaming, betting limits, casino self-control, online safety, 24/7 support",
    },
    notify: {
      /* prettier-ignore */
      "title": "🔔 AFun Notifications - Messages, Alerts & Promotions",
      /* prettier-ignore */
      "description": "Access all your AFun notifications in one place. Get real-time alerts about exclusive promotions, bonuses and the latest updates.",
      /* prettier-ignore */
      "keyword": "AFun notifications, promo alerts, casino messages, betting updates, exclusive bonuses",
    },
    menu: {
      /* prettier-ignore */
      "title": "📑 AFun Menu - Explore Casino, Sports & Promotions",
      /* prettier-ignore */
      "description": "Browse the AFun menu to find all sections in one place: slots, roulette, sports betting, promotions and more.",
      /* prettier-ignore */
      "keyword": "AFun menu, casino categories, slot games, sports betting, casino promotions",
    },
    settings: {
      /* prettier-ignore */
      "title": "⚙ AFun Settings - Account Preferences & Security",
      /* prettier-ignore */
      "description": "Manage your AFun settings. Update preferences, notifications, personal details and keep your account secure.",
      /* prettier-ignore */
      "keyword": "account settings, AFun preferences, casino notifications, online security, profile adjustments",
    },
    help: {
      /* prettier-ignore */
      "title": "❓ AFun Help - FAQ, Support & 24/7 Assistance",
      /* prettier-ignore */
      "description": "Get quick answers at the AFun Help Center. Browse FAQs, resolve your questions and contact our support team available 24/7.",
      /* prettier-ignore */
      "keyword": "AFun help, casino FAQ, 24/7 support, betting questions, customer service",
    },
    "bonus-game": {
      /* prettier-ignore */
      "title": "🎁 AFun Bonus Games - Free Spins & Multipliers",
      /* prettier-ignore */
      "description": "Discover AFun bonus games. Play slots with free spins, progressive jackpots and exclusive promotions for players in Brazil.",
      /* prettier-ignore */
      "keyword": "bonus games, free spins, multiplier slots, progressive jackpots, casino promotions",
    },
    affiliate: {
      /* prettier-ignore */
      "title": "💰 AFUN Affiliate Program – Casino & Sports Referral Earnings",
      /* prettier-ignore */
      "description": "Join the AFUN affiliate program and earn generous commissions by referring players to our casino and sports platform. Real-time tracking and full support.",
      /* prettier-ignore */
      "keyword": "AFUN affiliate, casino affiliate program, sports betting affiliate, passive income",
    },
    promotion: {
      /* prettier-ignore */
      "title": "🎉 AFUN Promotions – Exciting Rewards & Bonus Campaigns",
      /* prettier-ignore */
      "description": "Discover AFUN’s latest promotions: earn rewards, join bonus campaigns, and redeem offers for real benefits. Transparent terms and regular updates.",
      /* prettier-ignore */
      "keyword": "AFUN promotions, casino bonuses, bonus campaigns, online casino offers",
    },
    "promotion-details": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sponsorship: {
      /* prettier-ignore */
      "title": "🤝 AFUN Sponsorship – Partnerships with Esports & Sports",
      /* prettier-ignore */
      "description": "AFUN builds strong sponsorships with esports talents, athletes, and influencers. Official partnerships highlight our commitment to gaming and sports.",
      /* prettier-ignore */
      "keyword": "AFUN sponsorship, esports partnerships, sports collaboration, gaming sponsor",
    },
    nobru: {
      /* prettier-ignore */
      "title": "⭐ AFUN x Nobru – Brazilian Esports Champion & Ambassador",
      /* prettier-ignore */
      "description": "Meet Nobru, Brazilian esports legend and AFUN ambassador. From Free Fire world champion to brand partner, his journey inspires millions of gamers.",
      /* prettier-ignore */
      "keyword": "AFUN Nobru, esports champion, game ambassador, Free Fire Brazil",
    },
    "game-list": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    reset: {
      /* prettier-ignore */
      "title": "🔒 AFUN Account Reset – Recover or Change Password",
      /* prettier-ignore */
      "description": "Reset your AFUN account password easily by email, phone number or CPF. Secure recovery options ensure fast access back to your account.",
      /* prettier-ignore */
      "keyword": "AFUN reset password, account recovery, change password AFUN",
    },
    "bonus-rule": {
      /* prettier-ignore */
      "title": "Bonus Rules & Terms • How to Claim | AFUN",
      /* prettier-ignore */
      "description": "Read AFUN’s bonus rules: eligibility, claim steps, wagering requirements and withdrawal conditions. Learn how to claim welcome bonuses and promotions safely.",
      /* prettier-ignore */
      "keyword": "AFUN, bonus rules, claim bonus, wagering requirements, promotions",
    },
    "bet-detail": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    personalized: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sports: {
      /* prettier-ignore */
      "title": "⚽ AFUN Sports Betting – Live Odds & Major League Matches",
      /* prettier-ignore */
      "description": "Bet on football, basketball, tennis, esports and more with AFUN Sports. Enjoy live odds, boosted promotions, and secure betting on top leagues worldwide.",
      /* prettier-ignore */
      "keyword": "AFUN sports betting, live odds, football bets, basketball betting, online sportsbook",
    },
  },
  pt: {
    home: {
      /* prettier-ignore */
      "title": "🚀AFun Cassino Online - Jogos de Cassino Brasil",
      /* prettier-ignore */
      "description": "Afun - Jogue cassino online e apostas esportivas com bônus exclusivos no Brasil.",
      /* prettier-ignore */
      "keyword": "cassino online Brasil, apostas esportivas, bônus exclusivo, jogar slots, roleta online",
    },
    casino: {
      /* prettier-ignore */
      "title": "🎰 AFun Cassino Online - Slots, Roleta e Blackjack no Brasil",
      /* prettier-ignore */
      "description": "Afun - Mais de 2.000 jogos de cassino online. Slots populares como Tigrinho, roleta ao vivo e blackjack com dealers reais. PIX rápido e seguro no Brasil.",
      /* prettier-ignore */
      "keyword": "cassino online Brasil, jogos de slots, roleta online, blackjack, cassino ao vivo, PIX cassino",
    },
    profile: {
      /* prettier-ignore */
      "title": "👤 AFun Perfil do Jogador - Conta, Histórico e Bônus",
      /* prettier-ignore */
      "description": "Gerencie sua conta na AFun. Veja seu histórico de apostas, resgate bônus exclusivos e acompanhe seu saldo em tempo real.",
      /* prettier-ignore */
      "keyword": "perfil jogador, conta AFun, histórico apostas, bônus exclusivo, saldo online",
    },
    collections: {
      /* prettier-ignore */
      "title": "📂 AFun Coleções de Jogos - Slots, Roleta e Cassino Online",
      /* prettier-ignore */
      "description": "Explore as coleções exclusivas da AFun. Slots populares, roleta online, jackpots e jogos de cassino organizados para todos os estilos de jogador.",
      /* prettier-ignore */
      "keyword": "coleções de jogos, slots populares, roleta online, jackpots, cassino online Brasil",
    },
    "my-profile": {
      /* prettier-ignore */
      "title": "👤 AFun Minha Conta - Perfil, Apostas e Bônus Exclusivos",
      /* prettier-ignore */
      "description": "Acesse sua conta na AFun. Gerencie perfil, veja histórico de apostas, resgate bônus exclusivos e acompanhe seu saldo em tempo real.",
      /* prettier-ignore */
      "keyword": "minha conta AFun, perfil jogador, histórico de apostas, bônus exclusivo, saldo online",
    },
    feedback: {
      /* prettier-ignore */
      "title": "📝 AFun Feedback - Suporte e Contato com a Equipe",
      /* prettier-ignore */
      "description": "Envie seu feedback para a AFun. Fale com nossa equipe de suporte 24h, tire dúvidas e ajude a melhorar sua experiência de jogo online.",
      /* prettier-ignore */
      "keyword": "feedback AFun, suporte ao cliente, contato cassino, ajuda apostas, atendimento 24h",
    },
    "personalized-game": {
      /* prettier-ignore */
      "title": "🎮 AFun Jogos Personalizados - Recomendações Exclusivas para Você",
      /* prettier-ignore */
      "description": "Descubra jogos de cassino feitos sob medida para o seu perfil. Slots, roleta e blackjack recomendados de acordo com suas preferências na AFun.",
      /* prettier-ignore */
      "keyword": " jogos personalizados, recomendações cassino, slots favoritos, roleta online, blackjack Brasil",
    },
    "recent-game": {
      /* prettier-ignore */
      "title": "🕹 AFun Jogos Recentes - Continue de Onde Parou",
      /* prettier-ignore */
      "description": "Veja os últimos jogos que você jogou na AFun. Continue suas partidas favoritas em slots, roleta e blackjack de forma rápida e segura.",
      /* prettier-ignore */
      "keyword": " jogos recentes, últimos jogos, histórico cassino, slots favoritos, roleta online, blackjack",
    },
    install: {
      /* prettier-ignore */
      "title": "📲 Baixar App AFun - Instale o Cassino e Apostas no Celular",
      /* prettier-ignore */
      "description": "Baixe o aplicativo oficial da AFun. Instale no seu celular e tenha acesso rápido a cassino online, apostas esportivas e bônus exclusivos com PIX.",
      /* prettier-ignore */
      "keyword": "baixar app AFun, instalar aplicativo cassino, apostas esportivas app, cassino online Brasil, PIX mobile",
    },
    "wager-contest": {
      /* prettier-ignore */
      "title": "🏆 AFun Torneio de Apostas - Dispute Prêmios Exclusivos",
      /* prettier-ignore */
      "description": "articipe dos torneios de apostas da AFun. Suba no ranking, acumule pontos e conquiste prêmios exclusivos em slots e apostas esportivas.",
      /* prettier-ignore */
      "keyword": "torneio de apostas, competição cassino, ranking de jogadores, prêmios exclusivos, apostas esportivas",
    },
    competition: {
      /* prettier-ignore */
      "title": "🏆 AFun Torneio de Apostas - Dispute Prêmios Exclusivos",
      /* prettier-ignore */
      "description": "articipe dos torneios de apostas da AFun. Suba no ranking, acumule pontos e conquiste prêmios exclusivos em slots e apostas esportivas.",
      /* prettier-ignore */
      "keyword": "torneio de apostas, competição cassino, ranking de jogadores, prêmios exclusivos, apostas esportivas",
    },
    "hot-game": {
      /* prettier-ignore */
      "title": "🔥 AFun Jogos Populares - Slots e Cassino Mais Jogados",
      /* prettier-ignore */
      "description": "Descubra os jogos mais jogados na AFun. Slots famosos, roleta online, blackjack e muito mais em um só lugar.",
      /* prettier-ignore */
      "keyword": "jogos populares, slots famosos, roleta online, blackjack, cassino mais jogado",
    },
    "casual-games": {
      /* prettier-ignore */
      "title": "🎯 AFun Jogos Casuais - Diversão Rápida e Leve Online",
      /* prettier-ignore */
      "description": "Descubra os jogos casuais da AFun. Experiências rápidas e divertidas, perfeitas para relaxar entre suas apostas favoritas.",
      /* prettier-ignore */
      "keyword": "jogos casuais, diversão online, jogos leves, jogos rápidos, cassino Brasil",
    },
    vip: {
      /* prettier-ignore */
      "title": "👑 AFun VIP - Programa Exclusivo com Recompensas Especiais",
      /* prettier-ignore */
      "description": "Torne-se um membro VIP da AFun e aproveite bônus exclusivos, atendimento personalizado e vantagens únicas no cassino online.",
      /* prettier-ignore */
      "keyword": "AFun VIP, programa VIP cassino, bônus exclusivos, recompensas especiais, atendimento premium",
    },
    providers: {
      /* prettier-ignore */
      "title": "🎲 AFun Provedores de Jogos - Pragmatic Play, Evolution, NetEnt e Mais",
      /* prettier-ignore */
      "description": "Conheça os principais fornecedores da AFun, incluindo Pragmatic Play, Evolution, NetEnt, Red Tiger e muito mais. Jogos de cassino online autorizados e certificados no Brasil.",
      /* prettier-ignore */
      "keyword": "provedores cassino, fornecedores de jogos, Pragmatic Play Brasil, Evolution jogos, NetEnt slots, Red Tiger cassino, software autorizado",
    },
    responsible: {
      /* prettier-ignore */
      "title": "✅ AFun Jogo Responsável - Aposte com Segurança no Brasil",
      /* prettier-ignore */
      "description": "AFun promove o jogo responsável. Defina limites, jogue com consciência e conte com ferramentas de apoio para uma experiência segura e divertida.",
      /* prettier-ignore */
      "keyword": "jogo responsável, apostas seguras, limites de jogo, suporte cassino, conscientização",
    },
    "bonus-center": {
      /* prettier-ignore */
      "title": "🛡 AFun Jogo Responsável - Segurança e Autocontrole Online",
      /* prettier-ignore */
      "description": "AFun promove o jogo responsável. Defina limites, tenha ferramentas de autocontrole e jogue com total segurança e suporte 24h.",
      /* prettier-ignore */
      "keyword": "jogo responsável, limites de apostas, autocontrole cassino, segurança online, suporte 24h",
    },
    notify: {
      /* prettier-ignore */
      "title": "🔔 AFun Notificações - Mensagens, Alertas e Promoções",
      /* prettier-ignore */
      "description": "Veja todas as notificações da AFun em um só lugar. Receba alertas sobre promoções exclusivas, bônus e novidades em tempo real.",
      /* prettier-ignore */
      "keyword": "notificações AFun, alertas promoções, mensagens cassino, novidades apostas, bônus exclusivos",
    },
    menu: {
      /* prettier-ignore */
      "title": "📑 AFun Menu - Navegue por Cassino, Esportes e Promoções",
      /* prettier-ignore */
      "description": "Acesse o menu da AFun e encontre todos os jogos e seções: slots, roleta, apostas esportivas, promoções e muito mais em um só lugar.",
      /* prettier-ignore */
      "keyword": "menu cassino, categorias AFun, jogos slots, apostas esportivas, promoções cassino",
    },
    settings: {
      /* prettier-ignore */
      "title": "⚙ AFun Configurações - Preferências e Segurança da Conta",
      /* prettier-ignore */
      "description": "Gerencie suas configurações na AFun. Ajuste preferências, notificações, dados pessoais e mantenha sua conta segura.",
      /* prettier-ignore */
      "keyword": "configurações conta, preferências AFun, notificações cassino, segurança online, ajustes perfil",
    },
    help: {
      /* prettier-ignore */
      "title": "❓ AFun Ajuda - FAQ e Suporte ao Cliente 24h",
      /* prettier-ignore */
      "description": "Encontre respostas rápidas na central de ajuda da AFun. Consulte o FAQ, tire dúvidas e fale com nosso suporte disponível 24 horas.",
      /* prettier-ignore */
      "keyword": "ajuda AFun, FAQ cassino, suporte 24h, dúvidas apostas, atendimento cliente",
    },
    "bonus-game": {
      /* prettier-ignore */
      "title": "🎁 AFun Jogos Bônus - Rodadas Grátis e Multiplicadores",
      /* prettier-ignore */
      "description": "Explore os jogos bônus da AFun. Slots com rodadas grátis, jackpots progressivos e promoções exclusivas para jogadores no Brasil.",
      /* prettier-ignore */
      "keyword": "jogos bônus, rodadas grátis, slots com multiplicadores, jackpots progressivos, promoções cassino",
    },
    affiliate: {
      /* prettier-ignore */
      "title": "💰 Programa de Afiliados AFUN – Ganhe com Cassino & Esportes",
      /* prettier-ignore */
      "description": "Participe do programa de afiliados AFUN e receba comissões atrativas ao indicar jogadores para nosso cassino e apostas esportivas. Painel e suporte dedicado.\n",
      /* prettier-ignore */
      "keyword": "afiliados AFUN, programa de afiliados cassino, afiliado apostas esportivas, renda passiva",
    },
    promotion: {
      /* prettier-ignore */
      "title": "🎉 Promoções AFUN – Bônus Exclusivos & Campanhas Especiais",
      /* prettier-ignore */
      "description": "Confira as promoções da AFUN: ganhe recompensas, participe de campanhas de bônus e troque ofertas por benefícios reais. Termos claros e atualizações",
      /* prettier-ignore */
      "keyword": "promoções AFUN, bônus cassino, campanhas de bônus, ofertas cassino online",
    },
    "promotion-details": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sponsorship: {
      /* prettier-ignore */
      "title": "🤝 Patrocínio AFUN – Parcerias com Esports e Esportes",
      /* prettier-ignore */
      "description": "A AFUN fortalece parcerias com talentos de esports, atletas e influenciadores. Patrocínios oficiais que reforçam nosso compromisso com jogos e esportes.",
      /* prettier-ignore */
      "keyword": "patrocínio AFUN, parceria esports, colaboração esportiva, patrocinador de jogos",
    },
    nobru: {
      /* prettier-ignore */
      "title": "⭐ AFUN x Nobru – Campeão de Esports & Embaixador",
      /* prettier-ignore */
      "description": "Conheça Nobru, lenda dos esports e embaixador da AFUN. De campeão mundial de Free Fire a parceiro de marca, sua trajetória inspira milhões de jogadores.",
      /* prettier-ignore */
      "keyword": "AFUN Nobru, campeão esports, embaixador marca, Free Fire Brasil",
    },
    "game-list": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    reset: {
      /* prettier-ignore */
      "title": "🔒 Redefinir Conta AFUN – Recuperar ou Alterar Senha",
      /* prettier-ignore */
      "description": "Redefina sua senha da conta AFUN por e-mail, número de telefone ou CPF. Opções seguras de recuperação para acesso rápido à sua conta.",
      /* prettier-ignore */
      "keyword": "AFUN redefinir senha, recuperar conta, alterar senha AFUN",
    },
    "bonus-rule": {
      /* prettier-ignore */
      "title": "Regras de Bônus • Como Resgatar | AFUN",
      /* prettier-ignore */
      "description": "Confira as regras de bônus da AFUN: requisitos de participação, como resgatar, rollover e condições de saque. Saiba passo a passo como receber bônus de boas-vindas e promoções.",
      /* prettier-ignore */
      "keyword": "AFUN, regras de bônus, resgatar bônus, promoções, requisitos de apostas",
    },
    "bet-detail": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    personalized: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sports: {
      /* prettier-ignore */
      "title": "⚽ Apostas Esportivas AFUN – Odds Ao Vivo & Grandes Ligas",
      /* prettier-ignore */
      "description": "Aposte em futebol, basquete, tênis, esports e muito mais com a AFUN. Aproveite odds ao vivo, promoções turbinadas e apostas seguras nas maiores ligas.",
      /* prettier-ignore */
      "keyword": "apostas esportivas AFUN, odds ao vivo, apostas futebol, apostas basquete, casa de apostas online",
    },
  },
  es: {
    home: {
      /* prettier-ignore */
      "title": "🚀AFun Casino Online - Juegos de Casino y Apuestas en Brasil",
      /* prettier-ignore */
      "description": "Afun - Juega casino online y apuestas deportivas con bonos exclusivos en Brasil.",
      /* prettier-ignore */
      "keyword": "casino online Brasil, apuestas deportivas, bono exclusivo, tragamonedas, ruleta en vivo",
    },
    casino: {
      /* prettier-ignore */
      "title": "🎰 AFun Casino Online - Tragamonedas, Ruleta y Blackjack en Brasil",
      /* prettier-ignore */
      "description": " Afun - Más de 2.000 juegos de casino online. Tragamonedas populares como Fortune Tiger, ruleta en vivo y blackjack con crupieres reales. Depósitos rápidos vía PIX en Brasil.",
      /* prettier-ignore */
      "keyword": "casino online Brasil, tragamonedas, ruleta en vivo, blackjack, casino en vivo, pagos PIX",
    },
    profile: {
      /* prettier-ignore */
      "title": "👤 AFun Perfil del Jugador - Cuenta, Historial y Bonos",
      /* prettier-ignore */
      "description": "Administra tu cuenta en AFun. Consulta tu historial de apuestas, reclama bonos exclusivos y revisa tu saldo en tiempo real.",
      /* prettier-ignore */
      "keyword": " perfil jugador, cuenta AFun, historial apuestas, bonos exclusivos, saldo online",
    },
    collections: {
      /* prettier-ignore */
      "title": "📂 AFun Colecciones de Juegos - Tragamonedas, Ruleta y Casino Online",
      /* prettier-ignore */
      "description": "Explora las colecciones exclusivas de AFun. Tragamonedas populares, ruleta online, jackpots y juegos de casino en vivo para todos los estilos de jugador.",
      /* prettier-ignore */
      "keyword": "colecciones de juegos, tragamonedas populares, ruleta online, jackpots, casino online Brasil",
    },
    "my-profile": {
      /* prettier-ignore */
      "title": "👤 AFun Mi Cuenta - Perfil, Historial de Apuestas y Bonos",
      /* prettier-ignore */
      "description": "Ingresa a tu cuenta en AFun. Administra tu perfil, revisa tu historial de apuestas, reclama bonos exclusivos y controla tu saldo en tiempo real.",
      /* prettier-ignore */
      "keyword": "mi cuenta AFun, perfil jugador, historial apuestas, bonos exclusivos, saldo en línea",
    },
    feedback: {
      /* prettier-ignore */
      "title": "📝 AFun Feedback - Soporte al Cliente y Contacto",
      /* prettier-ignore */
      "description": "Envía tu feedback a AFun. Habla con nuestro soporte 24/7, resuelve dudas y ayuda a mejorar tu experiencia de juego online.",
      /* prettier-ignore */
      "keyword": "feedback AFun, soporte al cliente, contacto casino, ayuda apuestas, atención 24h",
    },
    "personalized-game": {
      /* prettier-ignore */
      "title": "🎮 AFun Juegos Personalizados - Recomendaciones Exclusivas para Ti",
      /* prettier-ignore */
      "description": "Descubre juegos de casino adaptados a tu perfil. Tragamonedas, ruleta y blackjack recomendados según tus preferencias en AFun.",
      /* prettier-ignore */
      "keyword": "juegos personalizados, recomendaciones casino, tragamonedas favoritas, ruleta online, blackjack Brasil",
    },
    "recent-game": {
      /* prettier-ignore */
      "title": "🕹 AFun Juegos Recientes - Continúa Donde lo Dejaste",
      /* prettier-ignore */
      "description": "Mira los últimos juegos que jugaste en AFun. Continúa con tus tragamonedas, ruleta y blackjack favoritos de forma rápida y segura.",
      /* prettier-ignore */
      "keyword": "juegos recientes, últimos juegos, historial casino, tragamonedas favoritas, ruleta online, blackjack",
    },
    install: {
      /* prettier-ignore */
      "title": "📲 Descargar App AFun - Instala Casino y Apuestas en tu Móvil",
      /* prettier-ignore */
      "description": "Descarga la aplicación oficial de AFun. Instálala en tu móvil y accede al casino online, apuestas deportivas y bonos exclusivos con PIX.",
      /* prettier-ignore */
      "keyword": "descargar app AFun, instalar app casino, app apuestas deportivas, casino online Brasil, PIX móvil",
    },
    "wager-contest": {
      /* prettier-ignore */
      "title": "🏆 AFun Torneo de Apuestas - Gana Premios Exclusivos",
      /* prettier-ignore */
      "description": "Únete a los torneos de apuestas de AFun. Sube en la clasificación, acumula puntos y gana premios exclusivos en tragamonedas y apuestas deportivas.",
      /* prettier-ignore */
      "keyword": "torneo de apuestas, competencia casino, ranking jugadores, premios exclusivos, apuestas deportivas",
    },
    competition: {
      /* prettier-ignore */
      "title": "🏆 AFun Torneo de Apuestas - Gana Premios Exclusivos",
      /* prettier-ignore */
      "description": "Únete a los torneos de apuestas de AFun. Sube en la clasificación, acumula puntos y gana premios exclusivos en tragamonedas y apuestas deportivas.",
      /* prettier-ignore */
      "keyword": "torneo de apuestas, competencia casino, ranking jugadores, premios exclusivos, apuestas deportivas",
    },
    "hot-game": {
      /* prettier-ignore */
      "title": "🔥 AFun Juegos Populares - Slots y Casino Más Jugados",
      /* prettier-ignore */
      "description": "Descubre los juegos más populares en AFun. Tragamonedas famosas, ruleta online, blackjack y mucho más en un solo lugar.",
      /* prettier-ignore */
      "keyword": "juegos populares, tragamonedas famosas, ruleta online, blackjack, juegos de casino más jugados",
    },
    "casual-games": {
      /* prettier-ignore */
      "title": "🎯 AFun Juegos Casuales - Diversión Rápida y Entretenida Online",
      /* prettier-ignore */
      "description": "Descubre los juegos casuales de AFun. Experiencias rápidas y divertidas, ideales para relajarte entre tus apuestas favoritas.",
      /* prettier-ignore */
      "keyword": "juegos casuales, diversión online, juegos rápidos, juegos ligeros, casino Brasil",
    },
    vip: {
      /* prettier-ignore */
      "title": "👑 AFun VIP - Programa Exclusivo con Recompensas Únicas",
      /* prettier-ignore */
      "description": "Hazte miembro VIP de AFun y disfruta de bonos exclusivos, atención personalizada y ventajas únicas en el casino online.",
      /* prettier-ignore */
      "keyword": "AFun VIP, programa VIP casino, bonos exclusivos, recompensas únicas, atención premium",
    },
    providers: {
      /* prettier-ignore */
      "title": "🎲 Proveedores de Juegos AFun - Pragmatic Play, Evolution, NetEnt y Más",
      /* prettier-ignore */
      "description": "Conoce los principales proveedores de juegos de AFun como Pragmatic Play, Evolution, NetEnt, Red Tiger y más. Juegos de casino online autorizados y certificados en Brasil.",
      /* prettier-ignore */
      "keyword": "proveedores de casino, socios de juegos, Pragmatic Play Brasil, Evolution casino, NetEnt tragamonedas, Red Tiger juegos, proveedores autorizados",
    },
    responsible: {
      /* prettier-ignore */
      "title": "✅ AFun Juego Responsable - Apuesta con Seguridad en Brasil",
      /* prettier-ignore */
      "description": "AFun promueve el juego responsable. Establece límites, juega de forma consciente y utiliza herramientas de apoyo para una experiencia segura y divertida.",
      /* prettier-ignore */
      "keyword": "juego responsable, apuestas seguras, límites de juego, soporte casino, juego consciente",
    },
    "bonus-center": {
      /* prettier-ignore */
      "title": "🛡 AFun Juego Responsable - Seguridad y Autocontrol Online",
      /* prettier-ignore */
      "description": "AFun promueve el juego responsable. Establece límites, utiliza herramientas de autocontrol y juega con total seguridad y soporte 24/7.",
      /* prettier-ignore */
      "keyword": "juego responsable, límites de apuestas, autocontrol casino, seguridad online, soporte 24h",
    },
    notify: {
      /* prettier-ignore */
      "title": "🔔 AFun Notificaciones - Mensajes, Alertas y Promociones",
      /* prettier-ignore */
      "description": "Consulta todas tus notificaciones de AFun en un solo lugar. Recibe alertas en tiempo real sobre promociones exclusivas, bonos y novedades.",
      /* prettier-ignore */
      "keyword": "notificaciones AFun, alertas promociones, mensajes casino, actualizaciones apuestas, bonos exclusivos",
    },
    menu: {
      /* prettier-ignore */
      "title": "📑 Menú AFun - Casino, Deportes y Promociones",
      /* prettier-ignore */
      "description": "Accede al menú de AFun y encuentra todas las secciones: tragamonedas, ruleta, apuestas deportivas, promociones y mucho más en un solo lugar.",
      /* prettier-ignore */
      "keyword": "menú casino, categorías AFun, tragamonedas, apuestas deportivas, promociones casino",
    },
    settings: {
      /* prettier-ignore */
      "title": "⚙ Configuración AFun - Preferencias y Seguridad de la Cuenta",
      /* prettier-ignore */
      "description": "Administra tu configuración en AFun. Ajusta preferencias, notificaciones, datos personales y mantén tu cuenta segura.",
      /* prettier-ignore */
      "keyword": "configuración cuenta, preferencias AFun, notificaciones casino, seguridad online, ajustes perfil",
    },
    help: {
      /* prettier-ignore */
      "title": "❓ AFun Ayuda - FAQ, Soporte y Atención 24h",
      /* prettier-ignore */
      "description": "Encuentra respuestas rápidas en el centro de ayuda de AFun. Consulta el FAQ, resuelve tus dudas y habla con nuestro soporte disponible 24/7.",
      /* prettier-ignore */
      "keyword": "ayuda AFun, FAQ casino, soporte 24h, dudas apuestas, servicio cliente",
    },
    "bonus-game": {
      /* prettier-ignore */
      "title": "🎁 AFun Juegos de Bonificación - Giros Gratis y Multiplicadores",
      /* prettier-ignore */
      "description": "Descubre los juegos de bonificación de AFun. Tragamonedas con giros gratis, jackpots progresivos y promociones exclusivas para jugadores en Brasil.",
      /* prettier-ignore */
      "keyword": "juegos de bonificación, giros gratis, tragamonedas con multiplicadores, jackpots progresivos, promociones casino",
    },
    affiliate: {
      /* prettier-ignore */
      "title": "💰 Programa de Afiliados AFUN – Casino y Deportes con Ganancias",
      /* prettier-ignore */
      "description": "Únete al programa de afiliados AFUN y gana comisiones atractivas al referir jugadores a nuestro casino y plataforma deportiva. Soporte y reportes claros.",
      /* prettier-ignore */
      "keyword": "afiliado AFUN, programa de afiliados casino, afiliado apuestas deportivas, ingresos pasivos",
    },
    promotion: {
      /* prettier-ignore */
      "title": "🎉 Promociones AFUN – Bonos Exclusivos & Recompensas",
      /* prettier-ignore */
      "description": "Descubre las promociones de AFUN: gana recompensas, participa en campañas de bonos y canjea ofertas por beneficios reales. Condiciones claras y actualizaciones.\n \n ",
      /* prettier-ignore */
      "keyword": "promociones AFUN, bonos de casino, campañas de bonos, ofertas de casino online",
    },
    "promotion-details": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sponsorship: {
      /* prettier-ignore */
      "title": "🤝 Patrocinio AFUN – Alianzas con Esports y Deportes",
      /* prettier-ignore */
      "description": "AFUN impulsa alianzas con talentos de esports, atletas e influencers. Patrocinios oficiales que muestran nuestro compromiso con juegos y deportes.",
      /* prettier-ignore */
      "keyword": "patrocinio AFUN, alianzas esports, colaboración deportiva, patrocinador de juegos",
    },
    nobru: {
      /* prettier-ignore */
      "title": "⭐ AFUN x Nobru – Campeón de Esports & Embajador",
      /* prettier-ignore */
      "description": "Conoce a Nobru, leyenda de los esports y embajador de AFUN. Desde campeón mundial de Free Fire hasta colaborador de marca, su camino inspira a millones.",
      /* prettier-ignore */
      "keyword": "AFUN Nobru, campeón esports, embajador de marca, Free Fire Brasil",
    },
    "game-list": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    reset: {
      /* prettier-ignore */
      "title": "🔒 Restablecer Cuenta AFUN – Recuperar o Cambiar Clave",
      /* prettier-ignore */
      "description": "Restablece la contraseña de tu cuenta AFUN con correo, teléfono o CPF. Opciones seguras de recuperación para volver a acceder rápidamente.",
      /* prettier-ignore */
      "keyword": "AFUN restablecer clave, recuperar cuenta, cambiar contraseña AFUN",
    },
    "bonus-rule": {
      /* prettier-ignore */
      "title": "Reglas de Bonos • Cómo Reclamar | AFUN",
      /* prettier-ignore */
      "description": "Consulta las reglas de bonos de AFUN: requisitos, cómo reclamar, condiciones de apuesta y retiro. Aprende a reclamar bonos de bienvenida y promociones correctamente.",
      /* prettier-ignore */
      "keyword": "AFUN, reglas de bono, reclamar bono, promociones, requisitos de apuesta",
    },
    "bet-detail": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    personalized: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sports: {
      /* prettier-ignore */
      "title": "⚽ Apuestas Deportivas AFUN – Cuotas en Vivo & Grandes Ligas",
      /* prettier-ignore */
      "description": "Apuesta en fútbol, baloncesto, tenis, esports y más con AFUN. Disfruta de cuotas en vivo, promociones mejoradas y apuestas seguras en ligas top.",
      /* prettier-ignore */
      "keyword": "apuestas deportivas AFUN, cuotas en vivo, apuestas fútbol, apuestas baloncesto, casa de apuestas online",
    },
  },
  hk: {
    home: {
      /* prettier-ignore */
      "title": "🚀AFun 巴西合法娛樂城 - 在線賭場與體育博彩",
      /* prettier-ignore */
      "description": "Afun - 在巴西安全下注，享受線上賭場與體育博彩獨家優惠。",
      /* prettier-ignore */
      "keyword": "巴西賭場, 體育博彩, 獨家紅利, 老虎機, 真人輪盤",
    },
    casino: {
      /* prettier-ignore */
      "title": "🎰 AFun 巴西娛樂城 - 老虎機、輪盤與二十一點",
      /* prettier-ignore */
      "description": "Afun - 超過 2000 款線上娛樂遊戲。熱門老虎機如小虎機、真人荷官輪盤與二十一點。PIX 快速安全付款，巴西合法娛樂城。",
      /* prettier-ignore */
      "keyword": "巴西娛樂城, 老虎機, 真人輪盤, 二十一點, 真人賭場, PIX 支付",
    },
    profile: {
      /* prettier-ignore */
      "title": "👤 AFun 玩家中心 - 帳號、投注紀錄與紅利",
      /* prettier-ignore */
      "description": "在 AFun 管理您的帳號，查看投注紀錄，領取專屬紅利，即時查詢餘額，享受安全便捷的博彩體驗。",
      /* prettier-ignore */
      "keyword": "玩家中心, 帳號管理, 投注紀錄, 獨家紅利, 即時餘額",
    },
    collections: {
      /* prettier-ignore */
      "title": "📂 AFun 遊戲合集 - 老虎機、輪盤與娛樂城遊戲",
      /* prettier-ignore */
      "description": "探索 AFun 獨家遊戲合集。熱門老虎機、線上輪盤、彩金獎池與真人娛樂城遊戲，滿足不同玩家需求。",
      /* prettier-ignore */
      "keyword": "遊戲合集, 老虎機, 線上輪盤, 彩金遊戲, 真人娛樂城",
    },
    "my-profile": {
      /* prettier-ignore */
      "title": "👤 AFun 我的帳號 - 玩家資料、投注紀錄與紅利",
      /* prettier-ignore */
      "description": "登入 AFun 帳號，管理個人資料，查看投注紀錄，領取專屬紅利，隨時查詢帳戶餘額。",
      /* prettier-ignore */
      "keyword": "我的帳號, 玩家資料, 投注紀錄, 獨家紅利, 帳戶餘額",
    },
    feedback: {
      /* prettier-ignore */
      "title": "📝 AFun 意見回饋 - 客服與聯絡方式",
      /* prettier-ignore */
      "description": "向 AFun 提交您的意見回饋。24 小時客服隨時為您解答疑問，協助提升您的線上博彩體驗。",
      /* prettier-ignore */
      "keyword": "AFun 意見回饋, 客服支援, 聯絡娛樂城, 投注幫助, 24小時服務",
    },
    "personalized-game": {
      /* prettier-ignore */
      "title": "🎮 AFun 個人化遊戲 - 為您專屬推薦的娛樂體驗",
      /* prettier-ignore */
      "description": "根據您的偏好，AFun 為您推薦專屬遊戲。熱門老虎機、線上輪盤與二十一點，量身打造專屬娛樂體驗。",
      /* prettier-ignore */
      "keyword": "個人化遊戲, 專屬推薦, 老虎機, 線上輪盤, 二十一點",
    },
    "recent-game": {
      /* prettier-ignore */
      "title": "🕹 AFun 最近遊戲 - 從您離開的地方繼續",
      /* prettier-ignore */
      "description": "查看您在 AFun 最近玩過的遊戲。快速繼續您喜愛的老虎機、輪盤與二十一點，體驗安全流暢。",
      /* prettier-ignore */
      "keyword": "最近遊戲, 遊戲紀錄, 娛樂城歷史, 老虎機, 線上輪盤, 二十一點",
    },
    install: {
      /* prettier-ignore */
      "title": "📲 下載 AFun APP - 手機安裝娛樂城與體育博彩",
      /* prettier-ignore */
      "description": "下載 AFun 官方 APP，立即安裝到您的手機。隨時進入線上娛樂城、體育博彩，享受 PIX 快速支付與專屬紅利。",
      /* prettier-ignore */
      "keyword": "下載AFun APP, 安裝娛樂城APP, 體育博彩APP, 線上賭場巴西, PIX 手機支付",
    },
    "wager-contest": {
      /* prettier-ignore */
      "title": "🏆 AFun 投注競賽 - 爭奪專屬獎勵",
      /* prettier-ignore */
      "description": "參加 AFun 投注競賽。提升玩家排名，累積積分，在老虎機與體育博彩中贏取專屬獎勵。",
      /* prettier-ignore */
      "keyword": "投注競賽, 娛樂城比賽, 玩家排名, 專屬獎勵, 體育博彩",
    },
    competition: {
      /* prettier-ignore */
      "title": "🏆 AFun 投注競賽 - 爭奪專屬獎勵",
      /* prettier-ignore */
      "description": "參加 AFun 投注競賽。提升玩家排名，累積積分，在老虎機與體育博彩中贏取專屬獎勵。",
      /* prettier-ignore */
      "keyword": "投注競賽, 娛樂城比賽, 玩家排名, 專屬獎勵, 體育博彩",
    },
    "hot-game": {
      /* prettier-ignore */
      "title": "🔥 AFun 熱門遊戲 - 最受歡迎的老虎機與娛樂城遊戲",
      /* prettier-ignore */
      "description": "探索 AFun 最受玩家喜愛的遊戲。熱門老虎機、線上輪盤、二十一點等通通齊全。",
      /* prettier-ignore */
      "keyword": "熱門遊戲, 老虎機, 線上輪盤, 二十一點, 娛樂城推薦",
    },
    "casual-games": {
      /* prettier-ignore */
      "title": "🎯 AFun 休閒遊戲 - 輕鬆有趣的線上娛樂體驗",
      /* prettier-ignore */
      "description": "索 AFun 精選休閒遊戲。快速又好玩的體驗，適合您在投注之餘放鬆心情。",
      /* prettier-ignore */
      "keyword": "休閒遊戲, 輕鬆娛樂, 快速遊戲, 線上娛樂, 巴西賭場",
    },
    vip: {
      /* prettier-ignore */
      "title": "👑 AFun VIP - 專屬會員計劃與尊享獎勵",
      /* prettier-ignore */
      "description": "加入 AFun VIP 計劃，享受專屬紅利、個人化服務與線上賭場尊享特權。",
      /* prettier-ignore */
      "keyword": "AFun VIP, VIP會員, 專屬紅利, 特別獎勵, 尊享服務",
    },
    providers: {
      /* prettier-ignore */
      "title": "🎲 AFun 遊戲供應商 - Pragmatic Play、Evolution、NetEnt 等",
      /* prettier-ignore */
      "description": "探索 AFun 的頂級遊戲供應商，包括 Pragmatic Play、Evolution、NetEnt、Red Tiger 等。所有遊戲均為正版授權，品質保證。",
      /* prettier-ignore */
      "keyword": "遊戲供應商, 娛樂城合作夥伴, Pragmatic Play 巴西, Evolution 賭場, NetEnt 老虎機, Red Tiger 遊戲, 授權遊戲",
    },
    responsible: {
      /* prettier-ignore */
      "title": "✅ AFun 負責任博彩 - 安全娛樂體驗",
      /* prettier-ignore */
      "description": "AFun 致力於推廣負責任博彩。您可以設定限額、理性娛樂，並使用多種支援工具，確保安全與樂趣並重。",
      /* prettier-ignore */
      "keyword": "負責任博彩, 安全投注, 限額設定, 娛樂城支援, 理性博彩",
    },
    "bonus-center": {
      /* prettier-ignore */
      "title": "🛡 AFun 負責任博彩 - 安全與自我控制",
      /* prettier-ignore */
      "description": "AFun 堅持推廣負責任博彩。提供限額設定與自我控制工具，並有 24 小時客服保障您的安全體驗。",
      /* prettier-ignore */
      "keyword": "負責任博彩, 投注限額, 自我控制, 線上安全, 24小時客服",
    },
    notify: {
      /* prettier-ignore */
      "title": "🔔 AFun 通知中心 - 消息、提醒與優惠",
      /* prettier-ignore */
      "description": "在這裡查看所有 AFun 通知。即時接收專屬優惠、紅利和最新活動提醒。",
      /* prettier-ignore */
      "keyword": "AFun 通知, 優惠提醒, 訊息中心, 投注更新, 專屬紅利",
    },
    menu: {
      /* prettier-ignore */
      "title": "📑 AFun 導覽選單 - 娛樂城、體育與優惠分類",
      /* prettier-ignore */
      "description": "在 AFun 選單中快速找到所有分類：老虎機、輪盤、體育博彩、優惠活動等，一站式導航。",
      /* prettier-ignore */
      "keyword": "AFun 選單, 娛樂城分類, 老虎機, 體育博彩, 優惠活動",
    },
    settings: {
      /* prettier-ignore */
      "title": "⚙ AFun 帳號設定 - 偏好與安全管理",
      /* prettier-ignore */
      "description": "在 AFun 管理您的設定。調整偏好、通知與個人資料，確保帳號安全。",
      /* prettier-ignore */
      "keyword": "帳號設定, 偏好管理, 通知中心, 線上安全, 個人資料",
    },
    help: {
      /* prettier-ignore */
      "title": "❓ AFun 幫助中心 - 常見問題與 24 小時客服",
      /* prettier-ignore */
      "description": "在 AFun 幫助中心快速找到答案。查看常見問題 FAQ，解決疑問，並與我們的 24 小時客服團隊聯繫。",
      /* prettier-ignore */
      "keyword": "AFun 幫助, FAQ 娛樂城, 24小時客服, 投注疑問, 客戶服務",
    },
    "bonus-game": {
      /* prettier-ignore */
      "title": "🎁 AFun 奖金遊戲 - 免費旋轉與倍數加成",
      /* prettier-ignore */
      "description": "探索 AFun 獎金遊戲。體驗老虎機免費旋轉、累積獎金與專屬優惠活動。",
      /* prettier-ignore */
      "keyword": "獎金遊戲, 免費旋轉, 倍數老虎機, 累積獎金, 娛樂城優惠",
    },
    affiliate: {
      /* prettier-ignore */
      "title": "💰 AFUN 聯盟計劃 — 娛樂城與體育合作推薦收益",
      /* prettier-ignore */
      "description": "加入 AFUN 聯盟計劃，推薦玩家即可獲得豐厚回報。提供即時追蹤、透明報表與專屬支援，助你輕鬆打造被動收入。",
      /* prettier-ignore */
      "keyword": "AFUN 聯盟, 娛樂城 ,聯盟計劃, 體育投注聯盟, 被動收入",
    },
    promotion: {
      /* prettier-ignore */
      "title": "🎉 AFUN 優惠活動 — 獎勵回饋與專屬紅利",
      /* prettier-ignore */
      "description": "探索 AFUN 最新優惠活動：參加紅利活動、獲取獎勵回饋、兌換專屬優惠。條款透明，內容即時更新，精彩不間斷。",
      /* prettier-ignore */
      "keyword": "AFUN 優惠, 娛樂城紅利, 獎勵活動, 線上娛樂城優惠",
    },
    "promotion-details": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sponsorship: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "🤝 AFUN 贊助計劃 — 電競與體育合作夥伴",
      /* prettier-ignore */
      "keyword": "AFUN 與電競選手、體育明星及意見領袖建立合作，透過官方贊助展現我們對遊戲與體育產業的長期承諾。",
    },
    nobru: {
      /* prettier-ignore */
      "title": "AFUN 贊助, 電競合作, 體育夥伴, 遊戲贊助",
      /* prettier-ignore */
      "description": "⭐ AFUN x Nobru — 電競冠軍與品牌大使",
      /* prettier-ignore */
      "keyword": "認識 Nobru：來自巴西的電競傳奇與 AFUN 品牌大使。從 Free Fire 世界冠軍到品牌合作典範，他的故事激勵無數玩家。",
    },
    "game-list": {
      /* prettier-ignore */
      "title": "AFUN Nobru, 電競冠軍, 品牌大使, FreeFire巴西",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    reset: {
      /* prettier-ignore */
      "title": "🔒 AFUN 帳號重設 — 找回或修改密碼",
      /* prettier-ignore */
      "description": "透過電子郵件、手機號或 CPF 輕鬆重設 AFUN 帳號密碼。安全的找回方式，幫助您快速恢復帳號訪問。",
      /* prettier-ignore */
      "keyword": "AFUN 重設密碼, 帳號 找回, 修改密碼AFUN",
    },
    "bonus-rule": {
      /* prettier-ignore */
      "title": "AFUN 獎金規則與優惠條款｜了解您的紅利玩法",
      /* prettier-ignore */
      "description": "在 AFUN 探索最新的紅利與獎金規則，清楚了解投注條件、流水要求與促銷條款，確保您輕鬆享受每一份專屬優惠。",
      /* prettier-ignore */
      "keyword": "AFUN, 獎金規則, 紅利條款, 優惠活動, 投注要求, 流水規則, 優惠中心",
    },
    "bet-detail": {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    personalized: {
      /* prettier-ignore */
      "title": "",
      /* prettier-ignore */
      "description": "",
      /* prettier-ignore */
      "keyword": "",
    },
    sports: {
      /* prettier-ignore */
      "title": "⚽ AFUN 體育投注 — 即時賠率 & 熱門賽事",
      /* prettier-ignore */
      "description": "在 AFUN 體育投注足球、籃球、網球、電競等熱門項目。即時賠率、優惠加成，安全可靠，盡享全球頂級聯賽下注體驗。",
      /* prettier-ignore */
      "keyword": "AFUN 體育, 即時賠率, 足球投注, 籃球投注, 線上體育博彩",
    },
  },
};
